import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {SymbolContainer} from "../reels/SymbolContainer";
import {IFinalEvaluatedArea} from "../server/Data";
import {SYMBOL} from "../enums/Enum";
import {GameUtils} from "../utils/GameUtils";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";

export class DeadReveal implements SimplePresentationRunner {
    shouldRun(): boolean {
        return true;
    }

    start(flowStateController: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            flowStateController.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });
        tl.add(this.playAllDeadReveal(), 0);

        tl.add(() => {
            flowStateController.finish();
        });
    }

    private playAllDeadReveal(): gsap.core.Timeline {
        const deadRevealTl: gsap.core.Timeline = new gsap.core.Timeline();
        Game.model.gameData.evaluatedArea.forEach((reels: string[], reelId: number) => {
            reels.forEach((sym: string, rowId: number) => {
                let subRowId: number = -1;
                Game.model.gameData.finalEvaluatedArea[reelId][rowId].forEach((finalEvaluatedArea: IFinalEvaluatedArea) => {
                    subRowId += finalEvaluatedArea.size;
                    if (finalEvaluatedArea.wasDead && finalEvaluatedArea.symTo !== SYMBOL.DEAD) {
                        const multiplier: number = finalEvaluatedArea.multiplier;
                        const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, rowId);
                        if (subRowId >= symbolContainer.symbols.length) {
                            if (NolimitConfig.isDevMode) {
                                debugger;
                            }
                            console.warn("dead reveal issue, reveal length is mis matched ", Game.model.gameData.finalEvaluatedArea[reelId][rowId], " ", symbolContainer.symbols);
                        }
                        const revealTo: string = finalEvaluatedArea.symTo;
                        deadRevealTl.add(symbolContainer.revealDeadSym(revealTo, subRowId, multiplier), 0);
                    }
                })
            });
        });
        return deadRevealTl;
    }

    private onSkip(tl: gsap.core.Timeline) {
        tl.timeScale(10);
    }

}